<template>
  <div class="el-message el-message--success is-closable" v-if="visible">
    <img src="../../../../static/images/error.png" class="el-message__icon"/>
    <p class="el-message__content">{{message}}</p>
    <img src="../../../../static/images/close.png" class="message__closeBtn" style=" cursor: pointer;" @click="close">
  </div>

</template>

<script type="text/babel">

  export default {
    data() {
      return {
        visible: false,
        onClose: null,
        onClick: null,
        zIndex: null,
        message:'',
        timer:null,
        closed:false,
      };
    },

    computed: {

    },

    watch: {

    },

    methods: {

      close() {
        this.closed = true;
        this.visible = false;
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
        if (typeof this.onClose === 'function') {
          this.onClose();
        }
      },
    },
    mounted() {
      if(this.duration > 0){
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.close();
          }
        }, this.duration);
      }
    },
    beforeDestroy() {

    }
  };

</script>


<style scoped>

  .el-message{
    min-width: 380px;
    box-sizing: border-box;
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: #ebeef5;
    position: absolute;
    left: 50%;
    top: 20px;
    transform: translateX(-50%);
    background-color: #edf2fc;
    overflow: hidden;
    padding: 15px 15px 15px 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    z-index: 6147483647;
  }
  .el-message--success {
    background-color: #fef0f0;
    border-color: #fde2e2;
  }
  .el-message.is-closable .el-message__content {
    padding-right: 16px;
    width: 80%;
  }
  .el-message--success .el-message__content {
    color: #f56c6c;
  }
  .el-message p {
    margin: 0;
  }
  .el-message__icon {
    margin-right: 10px;
  }
  .el-message__content {
    padding: 0;
    font-size: 14px;
    line-height: 1;
  }
  .el-message__closeBtn{
    color: #c0c4cc;
    font-size: 16px;
  }
</style>
